import { render, staticRenderFns } from "./DetailPayService.vue?vue&type=template&id=7dee2baa"
import script from "./DetailPayService.vue?vue&type=script&lang=ts"
export * from "./DetailPayService.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports